import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { baseAuthUrl } from '../authProvider';

const useStyles = makeStyles(theme => ({
    container: {
        position: 'relative'
    },
    icon: {
        position: 'absolute',
        width: 16,
        height: 16,
        left: 12,
        top: 12
    }
}));

export default function IconFolder({ iconURL }) {
    const classes = useStyles();

    return (
        <div className={classes.container}>
            <svg width="40" height="40" viewBox="0 0 46 46" fill="none" >
                <circle opacity="0.15" cx="23" cy="23" r="23" fill="#62BFD5" />
                <path opacity="0.6" d="M45 9.94617V12.263C45 11.2149 44.1418 10.3649 43.0837 10.3649H4.91635C3.85816 10.3649 3 11.2149 3 12.263V6.89815C3 5.85002 3.85816 5 4.91635 5H15.9625C16.2552 5 16.531 5.1364 16.7064 5.36843L18.4554 7.67959C18.6308 7.91162 18.9066 8.04802 19.1993 8.04802H43.0837C44.1418 8.04802 45 8.89803 45 9.94617Z" fill="#237FC2" />
                <path d="M45 35.6478V35.0607V34.4892V33.9024V33.3309V12.2634C45 11.2153 44.1418 10.3652 43.0837 10.3652H4.91635C3.85816 10.3652 3 11.2153 3 12.2634V33.3309V33.9024V34.4892V35.0607V35.6478L3.00077 36.2193C3.01616 36.6533 3.37619 37.0004 3.81816 37.0004H44.1822C44.6238 37.0004 44.9838 36.6533 44.9992 36.2193L45 35.6478Z" fill="#237FC2" />
            </svg>
            {iconURL && <img alt='' src={baseAuthUrl + '/' + iconURL} className={classes.icon} />}
        </div>
    )
}

IconFolder.propTypes = {
    iconURL: PropTypes.string
};
